import React from "react";
import { Eye, ExternalLink, Github } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-ink-border-subtle bg-ink-base">
      <div className="max-w-[1400px] mx-auto px-6 md:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          {/* Brand block */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-brand/20 to-brand/5 border border-brand/30 flex items-center justify-center">
                <Eye size={13} className="text-brand" />
              </div>
              <span className="text-white font-medium">
                N.E.T.R.A<span className="text-brand">.ai</span>
              </span>
            </div>
            <p className="mt-4 text-sm text-zinc-500 max-w-md leading-relaxed">
              A quieter, more honest way to read the internet. Built for
              journalists, students, researchers, and anyone who'd rather think
              than scroll.
            </p>

            {/* Horizon Flare India identity */}
            <div className="mt-6">
              <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 mb-2">
                An innovation lab project by
              </div>
              <div className="flex items-center gap-3">
                <img 
                  src="/logo-icon.png" 
                  alt="Horizon Flare India" 
                  className="w-8 h-8 rounded-lg border border-brand/30"
                />
                <div className="text-sm text-white">
                  Horizon Flare India
                </div>
              </div>
              <div className="mt-2 text-xs">
                <a
                  href="https://horizonflare.in"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="horizonflare-link-footer"
                  className="inline-flex items-center gap-1 text-zinc-400 hover:text-brand transition-colors duration-300"
                >
                  <span>Visit Horizon Flare India</span>
                  <ExternalLink size={11} className="opacity-60 group-hover:translate-x-0.5 transition-transform" />
                </a>
              </div>
            </div>
          </div>

          {/* Link columns */}
          <div className="md:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-x-8 gap-y-3 text-sm">
            <div className="space-y-2">
              <div className="text-xs text-zinc-600 uppercase tracking-wider">Product</div>
              <a href="/#why" className="block text-zinc-400 hover:text-white">Why N.E.T.R.A</a>
              <a href="/#how" className="block text-zinc-400 hover:text-white">How it works</a>
              <a href="/#voice" className="block text-zinc-400 hover:text-white">Voice mode</a>
              <a href="/app" className="block text-zinc-400 hover:text-white">Workspace</a>
            </div>
            <div className="space-y-2">
              <div className="text-xs text-zinc-600 uppercase tracking-wider">Company</div>
              <a
                href="https://horizonflare.in"
                target="_blank"
                rel="noreferrer"
                className="block text-zinc-400 hover:text-white"
              >
                Horizon Flare India
              </a>
              <a
                href="https://horizonflare.in"
                target="_blank"
                rel="noreferrer"
                className="block text-zinc-400 hover:text-white"
              >
                Innovation Lab
              </a>
              <a
                href="mailto:hello@horizonflare.in"
                className="block text-zinc-400 hover:text-white"
              >
                Contact
              </a>
            </div>
            <div className="space-y-2">
              <div className="text-xs text-zinc-600 uppercase tracking-wider">Resources</div>
              <a
                href="https://github.com/Mithilesh7723/NayanAI"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-1.5 text-zinc-400 hover:text-white"
              >
                <Github size={12} /> GitHub
              </a>
              <span className="block text-zinc-600">Privacy</span>
              <span className="block text-zinc-600">v1.0 Production</span>
            </div>
          </div>
        </div>

        {/* Bottom strip */}
        <div className="mt-12 pt-6 border-t border-ink-border-subtle flex flex-wrap items-center justify-between gap-3 text-xs text-zinc-600">
          <span>
            © {new Date().getFullYear()} N.E.T.R.A.ai · A{" "}
            <a
              href="https://horizonflare.in"
              target="_blank"
              rel="noreferrer"
              className="text-zinc-400 hover:text-brand transition-colors"
              data-testid="horizonflare-link-bottom"
            >
              Horizon Flare India
            </a>{" "}
            project · Made in India
          </span>
          <span className="font-serif italic text-zinc-500">crafted with patience.</span>
        </div>
      </div>
    </footer>
  );
}
